import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    programs: [],
    currentProgram: {},
    earningTypes: [],
    rewardTypes: [],
    myShops: [],
    simpleProducts: [],
    members: [],
    memberStats: {},
    currentMember: {},
    currentMemberTransactions: [],
    posMember: null,
    posAvailableRewards: [],
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
